<template>
  <div> </div>
 
</template>

<script>
/* eslint-disable no-undef */
// import SmartPressPopup from './SmartPressPopup.vue';

export default {
  name: 'GutenbergHandler',
  components: {
    // SmartPressPopup
  },
  data() {
    return {
      showPopup: false,
      selectedBlockContent: '',
      selectedBlockClientId: null,
      popupMode: 'generate', // 'generate' or 'rewrite'
      userPrompt: '',
      logoPath: window.smartpress_vars.pluginUrl + '/assets/smart-press-logo-150.png'
    };
  },
  mounted() {
    this.initGutenbergIntegration();
    this.injectCustomStyles();
  },
  methods: {
    initGutenbergIntegration() {
      // Make sure we have access to the wp object
      if (typeof wp === 'undefined' || !wp.blocks || !wp.editor) {
        // console.error('WordPress Gutenberg API not available');
        return;
      }

      // Register our custom SmartPress AI block
      this.registerSmartPressBlock();
      
      // Add menu item to block options
      this.addBlockMenuOptions();
    },
    
    injectCustomStyles() {
      // Inject custom styles to match branding
      const style = document.createElement('style');
      style.textContent = `
        .smartpress-generate-button {
          background-color: var(--smartpress-primary-color, #FF6266) !important;
          color: white !important;
          border: none !important;
          border-radius: 0.375rem !important;
          font-weight: normal !important;
          transition: all 0.3s ease-in-out !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        
        .smartpress-generate-button:hover {
          transform: scale(1.05) !important;
          opacity: 1 !important;
        }

        .smartpress-ai-content {
          border: 1px solid #e2e8f0 !important;
          padding: 12px !important;
          border-radius: 0.375rem !important;
          background-color: #fff !important;
          transition: all 0.2s ease !important;
        }

        .smartpress-ai-block-wrapper {
          border: 1px dashed var(--smartpress-secondary-color, #cbd5e0) !important;
          padding: 10px !important;
          margin: 10px 0 !important;
          border-radius: 0.375rem !important;
          position: relative !important;
        }

        .smartpress-ai-block-wrapper::before {
          content: '';
          position: absolute;
          top: -10px;
          left: 10px;
          background-color: var(--smartpress-primary-color, #FF6266);
          color: white;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 10px;
          z-index: 1;
        }
        
        .components-panel .components-panel__body-title {
          background-color: #f8f9fa !important;
          border-bottom: 1px solid #e2e8f0 !important;
        }
        
        .components-panel .components-panel__body {
          border: none !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        }
        
        .components-textarea-control__input {
          border-color: #e2e8f0 !important;
          border-radius: 0.375rem !important;
        }
        
        .smartpress-button-small {
          width: 25px !important;
          height: 25px !important;
          object-fit: contain !important;
          padding: 3px !important;
          border-radius: 50% !important;
          background-color: var(--smartpress-primary-color, #FF6266) !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2) !important;
        }
      `;
      document.head.appendChild(style);
    },
    
    createCustomIcon() {
      const { createElement } = wp.element;
      
      // Create a custom icon element with the image
      return createElement(
        'img',
        {
          src: this.logoPath,
          className: 'smartpress-button-small',
          style: {
            width: '25px',
            height: '25px',
            objectFit: 'contain',
            padding: '3px',
            borderRadius: '50%',
            backgroundColor: '#FF6266',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
          }
        }
      );
    },
    
    registerSmartPressBlock() {
      const { registerBlockType } = wp.blocks;
      const { RichText, InspectorControls } = wp.blockEditor || wp.editor;
      const { PanelBody, TextareaControl, Button } = wp.components;
      const { createElement, Fragment } = wp.element;
      
      // Create custom icon for the block
      const customIcon = this.createCustomIcon();
      
      registerBlockType('smartpress/ai-content', {
        title: 'SmartPress AI Content',
        icon: customIcon, // Use custom icon instead of 'text'
        category: 'common',
        attributes: {
          content: {
            type: 'string',
            source: 'html',
            selector: 'div.smartpress-ai-content'
          },
          prompt: {
            type: 'string',
            default: ''
          }
        },
        
        edit: (props) => {
          const { attributes, setAttributes, clientId } = props;
          
          // Handler for generating content
          const generateContent = () => {
            // Store the client ID for later use
            this.selectedBlockClientId = clientId;
            
            // Get the current content from the block to use as context
            // Safely extract content as a string
            let currentContent = '';
            try {
              // If it's a string, use it directly
              if (typeof attributes.content === 'string') {
                currentContent = attributes.content || '';
              }
              // If it's a rich text object, use toString or convert properly
              else if (attributes.content && typeof attributes.content === 'object') {
                // Try different methods to extract text
                if (typeof attributes.content.toString === 'function') {
                  currentContent = attributes.content.toString();
                } else if (wp.richText && typeof wp.richText.create === 'function' && typeof wp.richText.toHTMLString === 'function') {
                  const richTextContent = wp.richText.create({ html: attributes.content.html || '' });
                  currentContent = wp.richText.toHTMLString(richTextContent);
                } else {
                  // Fallback to empty string if we can't convert
                  currentContent = '';
                  console.warn('Could not convert rich text to string', attributes.content);
                }
              }
            } catch (e) {
              console.error('Error converting content to string:', e);
              currentContent = '';
            }
            
            // Get the "Selected text" textarea element from the settings panel
            const settingsPanel = document.querySelector('.components-panel');
            
            // Find the "ai-content" textarea (hidden textarea)
            const aiContentElement = settingsPanel ? 
              settingsPanel.querySelector('.smartpress-ai-content-textarea') : null;
            
            // Get element position
            const aiContentRect = aiContentElement ? aiContentElement.getBoundingClientRect() : null;
            
            // If element not found, fallback to block element
            if (!aiContentElement) {
              const blockElement = document.querySelector(`[data-block="${clientId}"]`);
              const blockRect = blockElement ? blockElement.getBoundingClientRect() : null;
              
              // Emit event to parent component to show popup
              this.$emit('show-popup', currentContent, blockRect, blockRect, blockElement, "html");
              return;
            }
            
            // Update the ai-content textarea with the current content
            if (aiContentElement) {
              aiContentElement.value = currentContent;
            }
            
            // Setup a MutationObserver to watch for changes to the ai-content textarea
            const setupAiContentObserver = () => {
              // Create an observer instance
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    // When value changes, update the block content
                    const newContent = aiContentElement.value;
                    setAttributes({ content: newContent });
                  }
                });
              });
              
              // Configuration of the observer
              const config = { attributes: true, attributeFilter: ['value'] };
              
              // Start observing the textarea
              observer.observe(aiContentElement, config);
              
              // Also listen for input events
              aiContentElement.addEventListener('input', () => {
                setAttributes({ content: aiContentElement.value });
              });
            };
            
            // Set up the observer
            setupAiContentObserver();
            
            // Emit event to parent component to show popup with the ai-content element
            this.$emit('show-popup', currentContent, aiContentRect, aiContentRect, aiContentElement, "html");
          };
          
          return createElement(
            Fragment,
            {},
            [
              // Inspector Controls (Sidebar)
              createElement(
                InspectorControls,
                {},
                createElement(
                  PanelBody,
                  { 
                    title: 'SmartPress AI Settings', 
                    initialOpen: true,
                    className: 'smartpress-panel-body'
                  },
                  [
                    createElement(
                      TextareaControl,
                      {
                        label: 'Selected text',
                        value: attributes.content || '',
                        disabled: true,
                        className: 'smartpress-textarea-control',
                        placeholder: 'Your selected content will appear here...',
                        rows: 4
                      }
                    ),
                    // Hidden AI Content Textarea
                    createElement(
                      'div',
                      { className: 'smartpress-hidden-textarea-container', style: { display: 'none' } },
                      createElement(
                        'textarea',
                        {
                          className: 'smartpress-ai-content-textarea',
                          value: attributes.content || '',
                          placeholder: 'AI generated content will appear here',
                          rows: 4,
                          onChange: (event) => {
                            // Update the block content when this textarea changes
                            setAttributes({ content: event.target.value });
                          }
                        }
                      )
                    ),
                    createElement(
                      Button,
                      {
                        isPrimary: true,
                        onClick: generateContent,
                        className: 'smartpress-generate-button',
                        style: {
                          backgroundColor: '#FF6266',
                          color: 'white',
                          border: 'none',
                          borderRadius: '0.375rem',
                          fontWeight: 'normal',
                          marginTop: '10px',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '6px',
                          padding: '8px 16px',
                          transition: 'all 0.3s ease-in-out',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                        }
                      },
                      [
                        // Create icon element to include before text
                        createElement(
                          'img',
                          {
                            src: this.logoPath,
                            style: {
                              width: '18px',
                              height: '18px',
                              marginRight: '4px'
                            }
                          }
                        ),
                        'Show SmartPress AI'
                      ]
                    )
                  ]
                )
              ),
              // Block Content
              createElement(
                'div',
                {
                  className: 'smartpress-ai-block-wrapper',
                },
                createElement(
                  RichText,
                  {
                    tagName: 'div',
                    className: 'smartpress-ai-content',
                    value: attributes.content,
                    onChange: (content) => {
                      setAttributes({ content });
                      
                      // Also update the hidden AI content textarea
                      const aiContentElement = document.querySelector('.smartpress-ai-content-textarea');
                      if (aiContentElement) {
                        aiContentElement.value = content;
                      }
                    },
                    placeholder: 'Your AI-generated content will appear here'
                  }
                )
              )
            ]
          );
        },
        
        save: (props) => {
          const { attributes } = props;
          const { createElement } = wp.element;
          const { RichText } = wp.blockEditor || wp.editor;
          
          return createElement(
            RichText.Content,
            {
              tagName: 'div',
              className: 'smartpress-ai-content',
              value: attributes.content
            }
          );
        }
      });
    },
    
    addBlockMenuOptions() {
      // Check if Gutenberg is available and loaded properly
      if (!wp.plugins || !wp.editPost || !wp.blocks || !wp.data) {
        console.error('Required WordPress modules not available');
        return;
      }
      
      const { registerPlugin } = wp.plugins;
      const { PluginBlockSettingsMenuItem } = wp.editPost;
      const { select } = wp.data;
      const { createElement } = wp.element;
      
      // Create custom icon for the menu item
      const customIcon = this.createCustomIcon();
      
      // Register our custom menu item plugin
      registerPlugin('smartpress-ai-menu', {
        render: () => {
          return createElement(
            PluginBlockSettingsMenuItem,
            {
              icon: customIcon, // Use custom icon instead of 'admin-customizer'
              label: 'Rewrite with SmartPress AI',
              className: 'smartpress-menu-item',
              onClick: () => {
                // Get the currently selected block
                const blockEditor = select('core/block-editor') || select('core/editor');
                const dispatch = wp.data.dispatch('core/block-editor') || wp.data.dispatch('core/editor');
                const selectedBlock = blockEditor.getSelectedBlock();
                
                if (selectedBlock) {
                  // Extract the content from the selected block
                  let content = '';
                  if (selectedBlock.attributes.content) {
                    content = selectedBlock.attributes.content;
                  } else if (selectedBlock.attributes.text) {
                    content = selectedBlock.attributes.text;
                  } else if (selectedBlock.attributes.value) {
                    content = selectedBlock.attributes.value;
                  } else {
                    // Try to get innerHTML as fallback
                    try {
                      const blockElement = document.querySelector(`[data-block="${selectedBlock.clientId}"]`);
                      if (blockElement) {
                        content = blockElement.innerHTML;
                      }
                    } catch (e) {
                      console.error('Could not extract content from block', e);
                    }
                  }
                  
                  // Set up the prompt for rewriting
                  const rewritePrompt = `rewrite content for: ${content.substring(0, 50)}${content.length > 50 ? '...' : ''}`;
                  
                  // Create a new SmartPress AI block to replace the current one
                  const newBlock = wp.blocks.createBlock('smartpress/ai-content', {
                    content: content,
                    prompt: rewritePrompt
                  });
                  
                  // Replace the selected block with our SmartPress AI block
                  dispatch.replaceBlock(selectedBlock.clientId, newBlock);
                  
                  // Store the new block's clientId for future reference
                  this.selectedBlockClientId = newBlock.clientId;
                  
                  // Optionally, generate content immediately
                  // const dummyRewrittenContent = `Rewritten content for: ${content.substring(0, 50)}${content.length > 50 ? '...' : ''}`;
                  
                  // Allow a moment for the block to fully initialize
                  setTimeout(() => {
                    dispatch.updateBlockAttributes(newBlock.clientId, {
                      content: content
                    });
                  }, 50);
                }
              }
            }
          );
        }
      });
    },
    
    closePopup() {
      this.showPopup = false;
    },
    
    applyGeneratedContent(content) {
      if (!this.selectedBlockClientId) return;
      
      // Get the block update function
      const blockEditor = wp.data.select('core/block-editor') || wp.data.select('core/editor');
      const dispatch = wp.data.dispatch('core/block-editor') || wp.data.dispatch('core/editor');
      
      // Get current selected block
      const selectedBlock = blockEditor.getBlocksByClientId(this.selectedBlockClientId)[0];
      
      if (selectedBlock) {
        // Update block content - handling might vary by block type
        const newAttributes = { ...selectedBlock.attributes };
        
        if ('content' in newAttributes) {
          newAttributes.content = content;
        } else if ('text' in newAttributes) {
          newAttributes.text = content;
        }
        
        dispatch.updateBlockAttributes(this.selectedBlockClientId, newAttributes);
      }
      
      this.closePopup();
    }
  }
};
</script>

<style>
/* CSS Variables for consistent branding */
:root {
  --smartpress-primary-color: #FF6266;
  --smartpress-secondary-color: #4a5568;
  --smartpress-bg-light: #f8fafc;
  --smartpress-text-dark: #1a202c;
  --smartpress-border-color: #e2e8f0;
  --smartpress-radius: 0.375rem;
  --smartpress-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* Block styling */
.smartpress-ai-block-wrapper {
  border: 1px dashed var(--smartpress-border-color);
  padding: 16px;
  margin: 10px 0;
  border-radius: var(--smartpress-radius);
  box-shadow: var(--smartpress-shadow);
  background-color: white;
  position: relative;
}

.smartpress-ai-block-wrapper::before {
  content: 'SmartPress AI';
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: var(--smartpress-primary-color);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  z-index: 1;
}

.smartpress-ai-content {
  border: 1px solid var(--smartpress-border-color);
  padding: 12px;
  border-radius: var(--smartpress-radius);
  background-color: white;
  transition: all 0.2s ease;
  min-height: 100px;
}

/* Button styling */
.smartpress-generate-button {
  background-color: var(--smartpress-primary-color) !important;
  color: white !important;
  border: none !important;
  border-radius: var(--smartpress-radius) !important;
  font-weight: normal !important;
  margin-top: 12px !important;
  width: 100% !important;
  transition: all 0.3s ease-in-out !important;
  box-shadow: var(--smartpress-shadow) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.smartpress-generate-button:hover {
  transform: scale(1.05) !important;
  opacity: 0.95 !important;
}

/* Sidebar panel styling */
.smartpress-panel-body .components-panel__body-title button {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--smartpress-text-dark) !important;
}

.smartpress-textarea-control textarea {
  border-color: var(--smartpress-border-color) !important;
  border-radius: var(--smartpress-radius) !important;
  padding: 8px !important;
  transition: border-color 0.2s ease !important;
}

.smartpress-textarea-control textarea:focus {
  border-color: var(--smartpress-primary-color) !important;
  box-shadow: 0 0 0 1px var(--smartpress-primary-color) !important;
}

/* Menu item styling */
.smartpress-menu-item {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.smartpress-button-small {
  width: 25px !important;
  height: 25px !important;
  object-fit: contain !important;
  padding: 3px !important;
  border-radius: 50% !important;
  background-color: var(--smartpress-primary-color) !important;
  box-shadow: var(--smartpress-shadow) !important;
}
</style>
